/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { PhoneCallTaskCreatePriority } from './phoneCallTaskCreatePriority';
import type { PhoneCallTaskCreateTaskNoteDoc } from './phoneCallTaskCreateTaskNoteDoc';

export interface PhoneCallTaskCreate {
  job_id: string;
  candidate_id: string;
  assignee_user_id: string;
  due_at?: string | null;
  priority?: PhoneCallTaskCreatePriority;
  title?: string | null;
  type: 'phone_call';
  task_note_doc?: PhoneCallTaskCreateTaskNoteDoc;
}
